(function () {
	const calcTop = (section) => {
		const imageWrapper = section.querySelector('.article-card__image-wrapper');
		let top = 0;

		if (imageWrapper) {
			top = imageWrapper.offsetHeight / 2;
		} else {
			top = 50;
		}

		return top;
	};

	const initFeaturedBlogMobileSliders = (isUpdate) => {
		const MOBILE_MAX = 749;

		const run = () => {
			const isMobile = window.innerWidth <= MOBILE_MAX;

			document.querySelectorAll('.js-featured-blog-mobile-slider').forEach((el) => {
				const paginationEl = el.querySelector('.featured-blog__pagination');

				if (isMobile) {
					if (!el.classList.contains('swiper-initialized')) {
						new Swiper(el, {
							slidesPerView: 1.5,
							spaceBetween: 12,
							centeredSlides: false,
							autoHeight: true,
							watchOverflow: true,
							/* Allow preventDefault on touchmove so horizontal swipe wins over page scroll */
							passiveListeners: false,
							touchReleaseOnEdges: true,
							threshold: 8,
							pagination: paginationEl
								? {
										el: paginationEl,
										clickable: true,
								  }
								: undefined,
						});
					} else if (el.swiper) {
						el.swiper.update();
					}
				} else if (el.swiper) {
					el.swiper.destroy(true, true);
				}
			});
		};

		run();

		if (isUpdate) {
			setTimeout(run, 400);
		}

		if (!window.__featuredBlogMobileResizeBound) {
			window.__featuredBlogMobileResizeBound = true;
			let resizeTimer;
			window.addEventListener('resize', () => {
				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(run, 150);
			});
		}
	};

	const initSlider = () => {
		const sliders = document.querySelectorAll('.blog__slider');

		sliders.forEach((slider) => {
			if (slider.classList.contains('swiper-initialized')) return;

			new Swiper(slider, {
				slidesPerView: 1,
				spaceBetween: 8,
				speed: 1000,
				navigation: {
					nextEl: slider.closest('.section-featured-blog')?.querySelector('.blog__slider-nav .swiper-button-next'),
					prevEl: slider.closest('.section-featured-blog')?.querySelector('.blog__slider-nav .swiper-button-prev'),
				},
				breakpoints: {
					576: {
						slidesPerView: 2.05,
						slidesPerGroup: 2,
					},
					990: {
						slidesPerView: 3.05,
						slidesPerGroup: 3,
					},
					1100: {
						slidesPerView: 3,
						slidesPerGroup: 3,
					},
				},
			});
		});
	};

	const initSection = () => {
		const sections = document.querySelectorAll('.section-featured-blog');

		const sectionResizeObserver = new ResizeObserver(() => {
			sections.forEach((section) => {
				const top = calcTop(section);
				const nav = section.querySelector('.blog__slider-nav');
				if (nav) nav.style.top = top + 'px';
			});
		});

		sections.forEach((section) => {
			sectionResizeObserver.observe(section);
		});

		initFeaturedBlogMobileSliders(true);
		initSlider();
	};

	initSection();

	if (!window.__featuredBlogShopifySectionLoad) {
		window.__featuredBlogShopifySectionLoad = true;
		document.addEventListener('shopify:section:load', function () {
			initSection();
		});
	}
})();
